import firebase from 'firebase/app';
import 'firebase/database';

const firebaseConfig2 = {
  apiKey: 'AIzaSyCPPAyT7ttBNpHfwTEkv1hu72-joxxHlOU',
  authDomain: 'atresmicroserviciospro.firebaseapp.com',
  databaseURL: 'https://atresmicroserviciospro.firebaseio.com',
  projectId: 'atresmicroserviciospro',
  storageBucket: 'atresmicroserviciospro.appspot.com',
  messagingSenderId: '600853899253',
  appId: '1:600853899253:web:7e25ed2da643d8e2f2a2bc'
};

const firebaseConfig = {
  apiKey: 'AIzaSyDhHTJ-yxU0h7VI1z6xJuTsdc-LVdA773M',
  authDomain: 'atresmicroserviciosdes.firebaseapp.com',
  databaseURL: 'https://atresmicroserviciosdes.firebaseio.com',
  projectId: 'atresmicroserviciosdes',
  storageBucket: 'atresmicroserviciosdes.appspot.com',
  messagingSenderId: '574492392308'
};

const firebaseConfig3 = {
  apiKey: 'AIzaSyDhHTJ-yxU0h7VI1z6xJuTsdc-LVdA773M',
  authDomain: 'atresmicroserviciosdes.firebaseapp.com',
  databaseURL: 'https://atresmicroserviciosdes-fcm.firebaseio.com',
  projectId: 'atresmicroserviciosdes',
  storageBucket: 'atresmicroserviciosdes.appspot.com',
  messagingSenderId: '574492392308'
};

const firebaseBackup = {
  apiKey: 'AIzaSyDhHTJ-yxU0h7VI1z6xJuTsdc-LVdA773M',
  authDomain: 'atresmicroserviciosdes.firebaseapp.com',
  databaseURL: 'https://atresmicroserviciosdes-tvbackup.firebaseio.com/',
  projectId: 'atresmicroserviciosdes',
  storageBucket: 'atresmicroserviciosdes.appspot.com',
  messagingSenderId: '574492392308'
};

/* 

const firebaseConfig = {
  apiKey: "AIzaSyD8TCrO0CC7z7yTt6qPHXC2Kb_0zYnDD-A",
  authDomain: "sites-380911.firebaseapp.com",
  databaseURL: "https://sites-380911-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "sites-380911",
  storageBucket: "sites-380911.appspot.com",
  messagingSenderId: "705033259281",
  appId: "1:705033259281:web:85baa94c7822c305d9a4b0"
};

const firebaseBackup = {
  apiKey: 'AIzaSyDhHTJ-yxU0h7VI1z6xJuTsdc-LVdA773M',
  authDomain: 'atresmicroserviciosdes.firebaseapp.com',
  databaseURL: 'https://atresmicroserviciosdes-tvbackup.firebaseio.com/',
  projectId: 'atresmicroserviciosdes',
  storageBucket: 'atresmicroserviciosdes.appspot.com',
  me
*/

export default () => {
  return {
    app1: firebase.initializeApp(firebaseConfig, 'db1'),
    app2: firebase.initializeApp(firebaseConfig2, 'db2'),
    app3: firebase.initializeApp(firebaseConfig3, 'db3'),
    appBackup: firebase.initializeApp(firebaseBackup, 'dbBackup'),
    firebase
  };
};
